import { render, staticRenderFns } from "./ScreeningProcessDetails.vue?vue&type=template&id=dfb3a51a&scoped=true&"
import script from "./ScreeningProcessDetails.vue?vue&type=script&lang=js&"
export * from "./ScreeningProcessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfb3a51a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSlideXReverseTransition } from 'vuetify/lib/components/transitions';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VCard,VCardText,VSlideXReverseTransition,VSlideXTransition,VSpacer,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dfb3a51a')) {
      api.createRecord('dfb3a51a', component.options)
    } else {
      api.reload('dfb3a51a', component.options)
    }
    module.hot.accept("./ScreeningProcessDetails.vue?vue&type=template&id=dfb3a51a&scoped=true&", function () {
      api.rerender('dfb3a51a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/ScreeningProcessDetails.vue"
export default component.exports